import { useRef, useMemo, useEffect } from 'react';
import useCreateCallbackForEvent from './useCreateCallbackForEvent';
const useGetUniqueFn = (fn, deps) => {
    const callBack = useCreateCallbackForEvent(fn);
    const idRef = useRef(0);
    useEffect(() => {
        return () => {
            idRef.current = idRef.current + 1;
        };
    }, []);
    const res = useMemo(() => {
        idRef.current = idRef.current + 1;
        const id = idRef.current;
        return (...res) => {
            if (id === idRef.current) {
                return callBack(...res);
            }
            else {
                console.log('useGetUniqueFn: Empty call');
            }
        };
    }, deps);
    return res;
};
export default useGetUniqueFn;
